import { useEffect, useState } from "react";
import VideoArea from "./videoArea";
import { handleVideoElementSizeInfo } from "redux-share/actions";
import { useAppSelector } from "redux-share/hooks";
import { conditions, videoTag } from "helpers";
import { ConditionName } from "interfaces";
import useFullScreen from "helpers/hooks/useFullScreen";
import Popovers from "../../player-components/popover/popovers";
import { shallowEqual } from 'react-redux'

const VideoPlayer = () => {

    const { firstPlay, showMiniPlayer, isFullScreen } = useAppSelector(({ controller: { firstPlay, showMiniPlayer, isFullScreen } }) => ({ firstPlay, showMiniPlayer, isFullScreen }), shallowEqual);
    const { params } = useAppSelector(({ videoData: { params } }) => ({ params }), shallowEqual);

    const [showScreen, setShowScreen] = useState<boolean>(false);

    useEffect(() => {
        const videoPlayerModule:any = document.getElementById("video-player-module");
        if (conditions(ConditionName.isDarkMode)) videoPlayerModule.classList.add("pl-bg-dark-1");
    }, [videoTag()])

    useEffect(() => {
        let timeout: any;
        const handleResize = () => {
            if(!conditions(ConditionName.showMiniPlayer)) {
                timeout = setTimeout(() => {
                    handleVideoElementSizeInfo();
                    setShowScreen(true);
                }, conditions(ConditionName.isTouchScreen) ? 0 : 500)
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            clearTimeout(timeout);
        }
    }, [firstPlay, showMiniPlayer, isFullScreen])


    useFullScreen();

    return (
        <>
            <div
                className={`dvh pl-transition-opacity pl-duration-500 ${showScreen ? "pl-opacity-100" : "pl-opacity-0"} ${conditions(ConditionName.backgroundColorInLightMode) ? "pl-bg-white" : "pl-bg-dark-1"} dark:pl-bg-dark-1 ${!!params.width ? params.width : "pl-w-screen"} ${!conditions(ConditionName.heightScreen) && params.height} pl-flex pl-items-start`}>
                <div 
                    id="parent-player"
                    className={`pl-w-full pl-h-full`}
                >
                    <VideoArea />
                </div>
            </div>
            <Popovers />
        </>
    )
}

export default VideoPlayer;